class AdhesiveAndGrout extends HTMLElement {
  constructor() {
    super();
    this.priceFormate = this.dataset.priceFormate; // e.g. '£{{amount}}'
    this.shopCurrency = this.dataset.shopCurrency;
    this.currentIso = this.dataset.currentIso;
    this.products = this.querySelectorAll('.main-Adhesive-text-button');
    this.totalPriceElbutton = this.querySelector('.Adhesive-btn-right.add-all'); // total price button
    this.totalPriceEl = this.querySelector('.total_price'); // total price element
    this.init();
  }

  init() {
    // Quantity change
    this.products.forEach((product) => {
      const qtyInput = product.querySelector('#quantity');
      if (qtyInput) {
        qtyInput.addEventListener('change', (event) => {
          event.preventDefault();
          this.changeQuantity(product);
        });
      }

      // Individual "Add" button
      const singleAdd = product.querySelector('.Adhesive-products-btn');
      if (singleAdd) {
        singleAdd.addEventListener('click', (event) => {
          event.preventDefault();
          event.target.disabled = true;
          this.addtocart(singleAdd);
        });
      }


      // ✅ Variant change listener
      const variantSelect = product.querySelector('.metaproduct-variants');
      const addButton = product.querySelector('.Adhesive-products-btn');
      if (variantSelect && addButton) {
        variantSelect.addEventListener('change', function () {
          const selectedVariant = this.value;
          addButton.setAttribute('data-variant-id', selectedVariant);
          console.log('Variant changed:', selectedVariant);
        });
      }

      if (product.dataset.joint) {
        const jointOptions = product.querySelector('.joint-options');
        if (jointOptions) {
          jointOptions.addEventListener('change', (event) => {
            const selectedJoint = event.target.value;
            product.dataset.joint = selectedJoint; // ✅ update data-joint
            this.changeQuantity(product); // ✅ recalculate instantly
            console.log(`Joint changed to ${selectedJoint}mm`);
          });
        }
      }
    });

    // "No Thanks" button
    const NoThanks = this.querySelector('.Adhesive-btn-left.no-thanks');
    if (NoThanks) {
      NoThanks.addEventListener('click', (event) => {
        event.preventDefault();
        this.hide();
      });
    }

    // ✅ "Add All" button — NEW FUNCTIONALITY
    if (this.totalPriceElbutton) {
      this.totalPriceElbutton.addEventListener('click', (event) => {
        event.preventDefault();
        this.addAllToCart();
      });
    }

    // Initial total calculation
    this.updateTotalPrice();
  }

  addtocart(button, skipSingle = false) {
    const parentId = this.dataset.prentId;
    const productBlock = button.closest('.Adhesive-products');
    const qtyInput = productBlock.querySelector('input[name="quantity"]');
    const quantity = parseInt(qtyInput.value) || 1;
    const variantId = button.getAttribute('data-variant-id');

    const data = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: {
            "Parent id": parentId,
          },
        },
      ],
    };

    // If skipSingle=true, return the item object (used by addAllToCart)
    if (skipSingle) {
      return data.items[0];
    }

    // Otherwise, proceed with normal single add
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        console.log('Added to cart:', response);
        document.dispatchEvent(new CustomEvent("cart:refresh", {
          detail: { scrollToTop: false },
        }));

        button.textContent = 'Added!';
        setTimeout(() => (button.textContent = 'Add'), 1500);
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
      });
  }

  // ✅ Add All Function
  addAllToCart() {
    const parentId = this.dataset.prentId;
    const allProducts = Array.from(this.products);

    // Filter only active (non-disabled) product blocks
    const activeProducts = allProducts.filter((product) => {
      const mainBtn = product.closest('.main-Adhesive-text-button');
      return mainBtn && !mainBtn.hasAttribute('disabled');
    });

    // Collect all active product items
    const items = activeProducts.map((product) => {
      const addButton = product.querySelector('.Adhesive-products-btn');
      return this.addtocart(addButton, true);
    }).filter(Boolean);

    if (items.length === 0) return;

    const data = { items };

    // Single bulk request
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        console.log('All products added:', response);

        // Trigger cart refresh
        document.dispatchEvent(new CustomEvent("cart:refresh", {
          detail: { scrollToTop: false },
        }));

        // Feedback for button
        this.totalPriceElbutton.textContent = 'All Added!';
        this.totalPriceElbutton.disabled = true;
        setTimeout(() => {
          this.totalPriceElbutton.textContent = 'Add All';
          this.totalPriceElbutton.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error adding all products:', error);
      });
  }

  hide() {
    this.parentElement.classList.add('hidden');
  }

  changeQuantity(product) {
    const priceFormat = this.priceFormate;
    const qtyInput = product.querySelector('#quantity');
    const priceEl = product.querySelector('[data-product-price]');
    const comparePriceEl = product.querySelector('[data-product-compare-price]');
    const btn = product.querySelector('.Adhesive-products-btn');

    const qty = parseInt(qtyInput.value) || 0;
    const price = parseInt(qtyInput.dataset.price) || 0;
    const comparePrice = parseInt(qtyInput.dataset.comparePrice) || 0;

    // ✅ Base price calculations
    const totalPrice = (price * qty) / 100;
    const totalComparePrice = (comparePrice * qty) / 100;

    const formattedPrice = priceFormat.replace('{{amount}}', totalPrice.toFixed(2));
    const formattedComparePrice = priceFormat.replace('{{amount}}', totalComparePrice.toFixed(2));

    if (priceEl) priceEl.textContent = formattedPrice;
    if (comparePriceEl) comparePriceEl.textContent = comparePrice > 0 ? formattedComparePrice : '';

    if (btn) btn.disabled = qty <= 0;

    // ✅ NEW: If grout product — recalculate based on joint width and tile size
    if (product.dataset.joint) {
      debugger
      const jointWidth = parseInt(product.dataset.joint) || 2;
      const root = product;
      const tileSize = root.dataset.tileSize;
      const totalArea = parseFloat(root.dataset.sqm || 0);

      // ✅ Determine coverage per bag based on tile size & joint width
      let coveragePerBag = 0;

      if (tileSize && (tileSize.includes('XS') || tileSize.includes('S') || tileSize.includes('Modular'))) {
        coveragePerBag = jointWidth === 2 ? 10 : 6;
      } else if (tileSize && tileSize.includes('M')) {
        coveragePerBag = 10;
      } else if (tileSize && tileSize.includes('L')) {
        coveragePerBag = 15;
      } else if (tileSize && tileSize.includes('XL')) {
        coveragePerBag = 20;
      } else {
        coveragePerBag = 0;
      }

      // ✅ Calculate required quantity
      const adhesiveUnitsQty = coveragePerBag > 0 ? Math.ceil(totalArea / coveragePerBag) : 1;

      // ✅ Update quantity input
      qtyInput.value = adhesiveUnitsQty;

      // ✅ Update prices again using new quantity
      const newTotal = (price * adhesiveUnitsQty) / 100;
      const formattedNewTotal = priceFormat.replace('{{amount}}', newTotal.toFixed(2));
      if (priceEl) priceEl.textContent = formattedNewTotal;

      console.log(`🧮 Joint: ${jointWidth}mm | Tile Size: ${tileSize} | Coverage: ${coveragePerBag}sqm/bag | Qty: ${adhesiveUnitsQty}`);
    }

    // ✅ Update global total price display
    this.updateTotalPrice();
  }


  updateTotalPrice() {
    const priceFormat = this.priceFormate;
    let total = 0;
    let hasQty = false;

    const allProducts = Array.from(this.products);
    const activeProducts = allProducts.filter((product) => {
      const mainBtn = product.closest('.main-Adhesive-text-button');
      return mainBtn && !mainBtn.hasAttribute('disabled');
    });

    activeProducts.forEach((product) => {
      const qtyInput = product.querySelector('#quantity');
      if (!qtyInput) return;

      const qty = parseInt(qtyInput.value) || 0;
      const price = parseInt(qtyInput.dataset.price) || 0;

      if (qty > 0) hasQty = true;
      total += (price * qty) / 100;
    });

    if (this.totalPriceEl) {
      const formattedTotal = priceFormat.replace('{{amount}}', total.toFixed(2));
      this.totalPriceEl.textContent = formattedTotal;
      this.totalPriceEl.classList.toggle('disabled', !hasQty);
    }

    if (this.totalPriceElbutton) {
      const allDisabled = allProducts.length > 0 && activeProducts.length === 0;
      this.totalPriceElbutton.disabled = allDisabled || !hasQty;

      // ✅ Toggle visibility of adhesive-and-grout element
      if (allDisabled) {
        this.parentElement.classList.add('hidden');
      } else {
        this.parentElement.classList.remove('hidden');
      }
    }
  }
}

customElements.define('adhesive-and-grout', AdhesiveAndGrout);
